// Persistenza configurazione v2 (richiesta Giuseppe: "se ricarico perdo le
// configurazioni"). Salva parametro + stato di TUTTI i toggle del pannello a
// ogni cambio; al boot li riapplica dispatchando i change (i moduli si
// attivano da soli). Deep-link e embed/bot hanno la precedenza.
const KEY = 'wsv2-state';
const TOGGLES = '#layersPanel .wsv2-toggle input[id], #ws-view-options-panel .wsv2-toggle input[id]';

function collect() {
    const state = { observationArea: document.getElementById('observationArea')?.value, parametro: document.getElementById('selectParametro')?.value, on: [], off: [] };
    // Toggle nel drawer + toggle di visualizzazione (popover iconcina occhio).
    document.querySelectorAll(TOGGLES).forEach(i => {
        if (i.dataset.persist === 'false') return;
        (i.checked ? state.on : state.off).push(i.id);
    });
    return state;
}

let saveT = null;
function scheduleSave() {
    clearTimeout(saveT);
    saveT = setTimeout(() => {
        try { localStorage.setItem(KEY, JSON.stringify(collect())); } catch (e) {}
    }, 250);
}

export function initPersist(urlState) {
    const embed = document.documentElement.classList.contains('wsv2-embed');
    if (embed) return; // gli embed/bot non ereditano né salvano

    // Capture-phase su document: intercetta anche i change che NON fanno
    // bubbling (eventi sintetici dei moduli, select nel pannello).
    document.addEventListener('change', scheduleSave, true);

    // Riapplica lo stato salvato SOLO sull'indirizzo base. Ogni link con una
    // query string è una vista forzata e deve partire dai default della mappa,
    // senza ereditare alcuna configurazione locale del browser.
    let saved = null;
    try { saved = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!saved || typeof saved !== 'object' || Array.isArray(saved)) return;
    const forcedUrl = urlState.raw.toString() !== '';

    // Migrazione del precedente livello separato (il suo periodo non era salvato).
    if (!forcedUrl && Array.isArray(saved.on) && saved.on.includes('ana-rainAccum')) saved.parametro = 'rain24h';
    if (saved.parametro && !forcedUrl) {
        const sel = document.getElementById('selectParametro');
        if (/^rain(?:1|3|6|12|24|48|72|96|120)h$/.test(saved.parametro)) {
            document.dispatchEvent(new CustomEvent('wsv2:rain-window-select', { detail: { value: saved.parametro } }));
        } else if (sel && sel.value !== saved.parametro && [...sel.options].some(o => o.value === saved.parametro)) {
            sel.value = saved.parametro;
            sel.dispatchEvent(new Event('change'));
        }
    }
    if (!forcedUrl) {
        const area = document.getElementById('observationArea');
        if (area && [...area.options].some(o => o.value === saved.observationArea) && area.value !== saved.observationArea) {
            area.value = saved.observationArea;
            area.dispatchEvent(new Event('change'));
        }
        // Default del pannello: alcuni toggle nascono ON (marker, quota…) e
        // altri OFF. Riapplichiamo ENTRAMBE le liste per riportare l'utente
        // esattamente dov'era.
        const controls = new Map([...document.querySelectorAll(TOGGLES)]
            .filter(c => c.dataset.persist !== 'false').map(c => [c.id, c]));
        for (const id of Array.isArray(saved.on) ? saved.on : []) {
            const c = controls.get(id);
            if (c && !c.checked) { c.checked = true; c.dispatchEvent(new Event('change')); }
        }
        for (const id of Array.isArray(saved.off) ? saved.off : []) {
            const c = controls.get(id);
            if (c && c.checked) { c.checked = false; c.dispatchEvent(new Event('change')); }
        }
    }
}
